import { useTranslation } from "react-i18next"
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded"

import useRoutes from "helpers/hooks/useRoutes"
import CustomLink from "widgets/common/CustomLink"

const AlertsOverviewLink = () => {
  const { t } = useTranslation()
  const { baseOrgURL } = useRoutes()

  return (
    <CustomLink
      href={`${baseOrgURL}/alerts`}
      variant="h6"
      bold
      underlineHover
      styles={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}
    >
      {t("alerts.ALERTS_OVERVIEW")}
      <ChevronRightRoundedIcon sx={{ fontSize: 18 }} />
    </CustomLink>
  )
}

export default AlertsOverviewLink
